/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoinMember
 */
export interface CoinMember {
    /**
     * The user's balance of the specific coin (in wei)
     * @type {number}
     * @memberof CoinMember
     */
    balance: number;
    /**
     * The ID of the user with a non-zero balance
     * @type {string}
     * @memberof CoinMember
     */
    userId: string;
}

/**
 * Check if a given object implements the CoinMember interface.
 */
export function instanceOfCoinMember(value: object): value is CoinMember {
    let isInstance = true;
    isInstance = isInstance && "balance" in value && value["balance"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;

    return isInstance;
}

export function CoinMemberFromJSON(json: any): CoinMember {
    return CoinMemberFromJSONTyped(json, false);
}

export function CoinMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'userId': json['user_id'],
    };
}

export function CoinMemberToJSON(value?: CoinMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'balance': value.balance,
        'user_id': value.userId,
    };
}

